export default function () {
  return !!$('.sitenavbar__toggle:visible')[0]
}
